import DataSyncDetailsStore from '../../../stores/DataSyncDetailsStore';
import ProductStoreFactory from '../../../stores/product/ProductStoreFactory';
import { OptimizelyProduct } from '../../../types/DataSyncItem';

export interface EndpointDisplayInfo {
  productName: string;
  iconPath: string;
}

const isSharedProductLabel = (product: OptimizelyProduct): boolean => (
  product === OptimizelyProduct.CGR || product === OptimizelyProduct.CMP
);

export const getSourceDisplayInfo = (dataSync?: DataSyncDetailsStore['dataSync']): EndpointDisplayInfo => {
  if (!dataSync?.source?.product) {
    return {
      productName: 'Source',
      iconPath: '/assets/data_platform.svg',
    };
  }

  const productStore = ProductStoreFactory.getSourceProductStore();
  const productInfo = productStore.getProduct(dataSync.source.product);
  const instance = productStore.getInstance(dataSync.source.product, dataSync.source.instance?.id);
  const sourceLabelFallback = productInfo?.text || 'Source';

  if (isSharedProductLabel(dataSync.source.product)) {
    return {
      productName: sourceLabelFallback,
      iconPath: productInfo?.iconPath
        || (dataSync.source.product === OptimizelyProduct.CMP ? '/assets/cmp.svg' : '/assets/data_platform.svg'),
    };
  }

  const sourceLabel = instance?.text || sourceLabelFallback;

  return {
    productName: sourceLabel,
    iconPath: instance?.iconPath
      || dataSync.source.object?.object_icon_url
      || productInfo?.iconPath
      || '/assets/data_platform.svg',
  };
};

export const getDestinationDisplayInfo = (dataSync?: DataSyncDetailsStore['dataSync']): EndpointDisplayInfo => {
  if (!dataSync?.destination?.product) {
    return {
      productName: 'Destination',
      iconPath: '/assets/data_platform.svg',
    };
  }

  const productStore = ProductStoreFactory.getDestinationProductStore();
  const productInfo = productStore.getProduct(dataSync.destination.product);
  const instance = productStore.getInstance(dataSync.destination.product, dataSync.destination.instance?.id);
  const destinationLabelFallback = productInfo?.text || 'Destination';

  if (isSharedProductLabel(dataSync.destination.product)) {
    return {
      productName: destinationLabelFallback,
      iconPath: productInfo?.iconPath
        || (dataSync.destination.product === OptimizelyProduct.CGR ? '/assets/content_graph.svg' : '/assets/cmp.svg'),
    };
  }

  const destinationLabel = instance?.text || destinationLabelFallback;

  return {
    productName: destinationLabel,
    iconPath: instance?.iconPath
      || dataSync.destination.object?.object_icon_url
      || productInfo?.iconPath
      || '/assets/data_platform.svg',
  };
};
